import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14b7291c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "investigations-main" }
const _hoisted_2 = {
  key: 0,
  class: "section-heading"
}
const _hoisted_3 = {
  key: 1,
  class: "section-heading"
}
const _hoisted_4 = { class: "section-heading" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Investigations", -1))
const _hoisted_6 = { class: "search" }
const _hoisted_7 = { class: "search-inputs" }
const _hoisted_8 = { class: "search-bar" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search fa-lg" })
], -1))
const _hoisted_10 = { class: "checkbox-button" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Active only")
], -1))
const _hoisted_12 = { class: "checkbox-button" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Cause driven only")
], -1))
const _hoisted_14 = { class: "checkbox-button" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "No investigator assigned")
], -1))
const _hoisted_16 = { class: "checkbox-button" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Reply required")
], -1))
const _hoisted_18 = { class: "checkbox-button" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Training only")
], -1))
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "seperator" }, null, -1))
const _hoisted_22 = { class: "filter" }
const _hoisted_23 = { class: "form-col" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigator", -1))
const _hoisted_25 = { class: "sml-select" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "form-col" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Supervisor", -1))
const _hoisted_30 = { class: "sml-select" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "form-col" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigation type", -1))
const _hoisted_35 = { class: "sml-select" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "All", -1))
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "form-col" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Timeframe", -1))
const _hoisted_40 = { class: "sml-select" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Last 3 months", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "6" }, "Last 6 months", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "12" }, "Last 1 year", -1))
const _hoisted_44 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = { class: "form-col" }
const _hoisted_46 = {
  key: 0,
  class: "reset-filter"
}
const _hoisted_47 = {
  class: "bottom-half",
  style: {"width":"100%","overflow":"auto"}
}
const _hoisted_48 = { class: "ls-table" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "text" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { key: 0 }
const _hoisted_54 = ["colspan"]
const _hoisted_55 = { key: 1 }
const _hoisted_56 = ["colspan"]
const _hoisted_57 = { key: 2 }
const _hoisted_58 = ["colspan"]
const _hoisted_59 = { "data-label": "Practice name" }
const _hoisted_60 = { "data-label": "Practice ID" }
const _hoisted_61 = { "data-label": "Commencement date" }
const _hoisted_62 = { "data-label": "Investigation type" }
const _hoisted_63 = { "data-label": "Appointment status" }
const _hoisted_64 = {
  key: 0,
  class: "fal fa-info-circle pa-1"
}
const _hoisted_65 = { "data-label": "Reply actions" }
const _hoisted_66 = { "data-label": "Status" }
const _hoisted_67 = {
  key: 0,
  "data-label": "Investigator"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 1,
  "data-label": "Investigator"
}
const _hoisted_70 = { "data-label": "actions" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["disabled", "onClick"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Cancel investigation", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Are you sure you want to cancel the investigation?", -1))

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_router_link = _resolveComponent("router-link")
  const _component_AlertBox = _resolveComponent("AlertBox")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.loadingDataSet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_LoadingIndicator)
        ]))
      : (_ctx.errorLoadingDataSet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_ErrorIndicator)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Search practice name or ID",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.searchKeyword]
                    ]),
                    _hoisted_9
                  ]),
                  _createElementVNode("label", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showActiveStatus) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.showActiveStatus]
                    ]),
                    _hoisted_11
                  ]),
                  _createElementVNode("label", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showCauseDrivenOnly) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.showCauseDrivenOnly]
                    ]),
                    _hoisted_13
                  ]),
                  _createElementVNode("label", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.noInvestigatorAssigned) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.noInvestigatorAssigned]
                    ]),
                    _hoisted_15
                  ]),
                  _createElementVNode("label", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.isReplyRequired) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.isReplyRequired]
                    ]),
                    _hoisted_17
                  ]),
                  _createElementVNode("label", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.showTrainingStatus) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.showTrainingStatus]
                    ]),
                    _hoisted_19
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn btn-default transparent mr-2",
                  disabled: _ctx.loadingContent || _ctx.errorLoadingContent,
                  onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.showAdvancedFilter = !_ctx.showAdvancedFilter), ["prevent","stop"]))
                }, [
                  _createTextVNode(" Advanced Filter"),
                  _createElementVNode("span", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(['fal', _ctx.showAdvancedFilter ? 'fa-angle-up' : 'fa-angle-down'])
                    }, null, 2)
                  ])
                ], 8, _hoisted_20)
              ]),
              (_ctx.showAdvancedFilter)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.advanceFilter.trustTeamMemberId) = $event))
                          }, [
                            _hoisted_26,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigators, (i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: i.id
                              }, _toDisplayString(i.firstName) + " " + _toDisplayString(i.lastName), 9, _hoisted_27))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.advanceFilter.trustTeamMemberId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.advanceFilter.supervisorId) = $event))
                          }, [
                            _hoisted_31,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supervisorList, (s) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: s.id
                              }, _toDisplayString(s.displayName), 9, _hoisted_32))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.advanceFilter.supervisorId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.advanceFilter.investigationTypeId) = $event))
                          }, [
                            _hoisted_36,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investigationTypes, (iT) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: iT.id
                              }, _toDisplayString(iT.name), 9, _hoisted_37))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.advanceFilter.investigationTypeId]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("div", _hoisted_40, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.advanceFilter.timeFrame) = $event))
                          }, _hoisted_44, 512), [
                            [_vModelSelect, _ctx.advanceFilter.timeFrame]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary sml",
                          onClick: _cache[11] || (_cache[11] = $event => (_ctx.applyFilter()))
                        }, " Apply filter ")
                      ])
                    ]),
                    (_ctx.filterApplied)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createTextVNode(" Or "),
                          _createElementVNode("a", {
                            class: "link2",
                            onClick: _cache[12] || (_cache[12] = $event => {_ctx.resetFilter();})
                          }, "reset all")
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("table", _hoisted_48, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
                      return (_openBlock(), _createElementBlock("th", {
                        class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                        onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(h.text), 1),
                          (h.sortable)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', h.sortMethod])
                              }, _hoisted_52, 2))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_49))
                    }), 256))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_ctx.loadingContent)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                        _createElementVNode("td", {
                          colspan: _ctx.tableHeadings.length
                        }, [
                          _createVNode(_component_LoadingIndicator)
                        ], 8, _hoisted_54)
                      ]))
                    : (_ctx.errorLoadingContent)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                          _createElementVNode("td", {
                            colspan: _ctx.tableHeadings.length
                          }, [
                            _createVNode(_component_ErrorIndicator)
                          ], 8, _hoisted_56)
                        ]))
                      : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.investigations.length == 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                            _createElementVNode("td", {
                              colspan: _ctx.tableHeadings.length
                            }, "No Records", 8, _hoisted_58)
                          ]))
                        : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.investigations.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.investigationsDisplay, (i) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", _hoisted_59, [
                                  _createVNode(_component_router_link, {
                                    to: { name: _ctx.RouteN.TA.Practice.n, query: { pId: i.latestPracticeLogData.practiceId } },
                                    class: "link",
                                    title: i.investigationStatus?.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(i.latestPracticeLogData.branchId == null ? i.latestPracticeLogData.name :
                    i.latestPracticeLogData.name + ' (' + i.latestPracticeLogData.branchTradingName +
                    ')'), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "title"])
                                ]),
                                _createElementVNode("td", _hoisted_60, _toDisplayString(i.latestPracticeLogData.branchId == null ?
                  i.latestPracticeLogData.firmId : i.latestPracticeLogData.firmId + ' - ' +
                  i.latestPracticeLogData.branchId), 1),
                                _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.$formatDate(i.commencementDate)), 1),
                                _createElementVNode("td", _hoisted_62, _toDisplayString(i.investigationTypeName), 1),
                                _createElementVNode("td", _hoisted_63, [
                                  _createTextVNode(_toDisplayString(i.appointmentStatus) + " ", 1),
                                  (i.appointments.length > 1)
                                    ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_64, null, 512)), [
                                        [_directive_tippy, {content: _ctx.appointmentsTippy(i.appointments)}]
                                      ])
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_65, _toDisplayString(i.isReplyRequired ? 'Yes' : ''), 1),
                                _createElementVNode("td", _hoisted_66, _toDisplayString(i.status), 1),
                                (!i.trustTeamMember)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_67, [
                                      (_ctx.$accessPermitted(_ctx.usrAcct.user.roles, [_ctx.$roleType().TrustAdmin]))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-default sml transparent",
                                            onClick: _withModifiers($event => (_ctx.assignInvestigator(i)), ["prevent","stop"])
                                          }, " Assign ", 8, _hoisted_68))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_69, _toDisplayString(i.investigator), 1)),
                                _createElementVNode("td", _hoisted_70, [
                                  _withDirectives(_createElementVNode("i", {
                                    onClick: $event => (_ctx.exportDataCSV(i)),
                                    style: {"cursor":"pointer"},
                                    class: "fal fa-file-csv mr-2"
                                  }, null, 8, _hoisted_71), [
                                    [_directive_tippy, { content: 'Data file' }]
                                  ]),
                                  _withDirectives(_createElementVNode("i", {
                                    onClick: $event => (_ctx.exportCostCSV(i)),
                                    style: {"cursor":"pointer"},
                                    class: "fal fa-file-csv"
                                  }, null, 8, _hoisted_72), [
                                    [_directive_tippy, { content: 'Cost file' }]
                                  ]),
                                  (_ctx.isSuperAdmin)
                                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-default sml ml-2",
                                        disabled: i.investigationStatus.id == 5,
                                        onClick: $event => (_ctx.cancelInvestigation(i.id))
                                      }, [
                                        _createTextVNode("Cancel")
                                      ], 8, _hoisted_73)), [
                                        [_directive_tippy, { content: 'Cancel investigation'}]
                                      ])
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 256))
                          : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 64)),
    (_ctx.cancelInvestigationAlert)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 3,
          onClose: _cache[15] || (_cache[15] = $event => (_ctx.cancelInvestigationAlert = false))
        }, {
          header: _withCtx(() => [
            _hoisted_74
          ]),
          body: _withCtx(() => [
            _hoisted_75
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-tertiary",
              onClick: _cache[13] || (_cache[13] = $event => (_ctx.cancelInvestigationAlert = false))
            }, "Back"),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[14] || (_cache[14] = (...args) => (_ctx.continueClicked && _ctx.continueClicked(...args)))
            }, "Continue")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}